module.exports = __webpack_public_path__ + "img/herb-2.cee1f82a.png";